const SVRS_OUTAGE_PATTERNS = [
  /sql server/i,
  /server was not found or was not accessible/i,
  /temporarily unavailable/i,
  /runtime error/i,
  /internal server error/i
];

const getSefazDocumentStatus = (link) => {
  const section = link.closest('.indentacaoNormal');
  const title = section?.previousElementSibling;
  const titleText = title?.classList.contains('tituloSessao') ? title.textContent.trim() : '';
  const normalizedTitle = titleText.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

  if (normalizedTitle.includes('nao vigente')) return 'Documentos não vigentes';
  if (normalizedTitle.includes('vigente')) return 'Documentos vigentes';
  return 'Documento';
};

const isSvrsPortal = (portal) => portal?.baseUrl?.includes('svrs.rs.gov.br');

const detectSvrsOutageContent = (content = '') => {
  if (!content) return false;
  return SVRS_OUTAGE_PATTERNS.some((pattern) => pattern.test(content));
};

const buildThirdPartyPortalNotice = (portalLabel, isSvrs, payload = {}) => {
  const isTimeout = payload?.code === 'portal_timeout' || payload?.reason === 'timeout_waiting_portal_response';

  return {
    kind: isTimeout ? 'timeout' : 'outage',
    title: isTimeout
      ? (isSvrs ? 'Portal da SVRS sem resposta' : 'Portal sem resposta')
      : (isSvrs ? 'Portal da SVRS indisponível' : 'Portal temporariamente indisponível'),
    warning: isTimeout
      ? 'O portal não respondeu a tempo'
      : (isSvrs ? 'Instabilidade no serviço de terceiro' : 'Falha no portal consultado'),
    text: isTimeout
      ? `O portal ${portalLabel} não respondeu dentro do tempo esperado. Verifique a disponibilidade do site do portal e tente novamente em alguns instantes.`
      : (payload?.error || (isSvrs
        ? `O portal ${portalLabel} está indisponível no momento. Isso não é falha do Monitor Fiscal, mas sim uma instabilidade no serviço de terceiro.`
        : `O portal ${portalLabel} está indisponível no momento.`)),
    code: payload?.code || null,
    reason: payload?.reason || null,
    details: payload?.details || null
  };
};

const readJsonErrorResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';

  if (contentType.includes('application/json')) {
    try {
      return await response.json();
    } catch {
      return null;
    }
  }

  const text = await response.text();
  return text ? { error: text } : null;
};

export {
  buildThirdPartyPortalNotice,
  detectSvrsOutageContent,
  getSefazDocumentStatus,
  isSvrsPortal,
  readJsonErrorResponse
};
